import { Icon } from '@/app/components/icons';
import { IconMoodBad } from '@/app/components/icons/social/icon-mood-bad';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

export const EMPTY_STATE_DATA = {
  title: 'ไม่พบข้อมูล',
  titleBySearch: 'กรุณาลองใหม่อีกครั้ง',
  description: `ตรวจดูให้แน่ใจว่าข้อความของคุณสะกดถูกต้อง <br />กรุณาค้นหาจาก <strong>จังหวัด, เขต, เลขไปรษณีย์, <span>ชื่อโชว์รูม หรือ ชื่อศูนย์บริการ</span></strong>`,
};

interface DealerEmptyStateProps {
  className?: string;
  title?: string;
  fullScreen?: boolean;
}

export const DealerEmptyState = ({
  className,
  title,
  fullScreen = false,
}: DealerEmptyStateProps) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-y-4',
        {
          'py-10': !fullScreen,
          'bg-silver-100 h-full min-h-48 rounded-sm': fullScreen,
        },
        className
      )}
      {...createDataAttributes({
        test: 'dealer-not-found',
      })}
    >
      <Icon className="text-red-500" size="2xl" icon={<IconMoodBad />} />
      <p className="text-sub-h2 font-noto-bold">
        {title || EMPTY_STATE_DATA.title}
      </p>
      <div
        className="text-body-2-fixed where-span:text-inline-wrap text-center text-gray-700"
        dangerouslySetInnerHTML={{ __html: EMPTY_STATE_DATA.description }}
      />
    </div>
  );
};
